import { SupportTip } from '@pt/models';
import { fillArr } from '@hglobal/common';

export function getTipsMock(count = 12): SupportTip[] {
  return fillArr(count, i => ({
    id: i,
    question: `Question ${i}`,
    answer: `Answer ${i}`,
  }));
}
